import StoreParams from "../../plugins/store-params"
import AccessData from "access-data-parser"
import Cookie from "js-cookie"

import parseUrl from "parse-url";
const getUtmTestData = require("./utm_generator_tests");

if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, "includes", {
		enumerable: false,
		value: function (obj) {
			let newArr = this.filter(function (el) {
				return el == obj;
			});
			return newArr.length > 0;
		}
	});
}

export default class UtmGenerator {
	constructor() {
		this.oldCookiesModel = {
			'__utmz=': {
				'utmcsr=': 'source',
				'utmcmd=': 'medium',
				'utmccn=': 'campaign',
				'utmctr=': 'term',
				'utmcct=': 'content',
				'utmgclid=': 'gclid',
			},
			'drfbaid=': 'fbaid',
			'drlicid=': 'licid',
		};
		this.storeModel = [
			{url: 'utm_source', 	utm: 'source'},
			{url: 'utm_medium', 	utm: 'medium'},
			{url: 'utm_campaign', 	utm: 'campaign'},
			{url: 'utm_content', 	utm: 'content'},
			{url: 'utm_term', 		utm: 'term'},
			{url: 'gclid', 			utm: 'gclid'},
			{url: 'fbaid', 			utm: 'fbaid'},
			{url: 'licid', 			utm: 'licid'},
			{url: 'mkt_tok', 		utm: 'mkt_tok'},
		];
		this.prefix = 'dr_';
		this.referrer = null;
		this.params = {};
		this.analyzedParams = {};
		this.utm = {
			source: '-',
			medium: '-',
			campaign: '-',
			content: '-',
			term: '-',
			gclid: '-',
			fbaid: '-',
			licid: '-',
			mkt_tok: '-',
		};
		this.utmStorage = null;
		this.hasOldUtm = false;
		this.isTestMode = false;
		this.testParams = {};

		try {
			// Do main stuff
			this.processUtmData();
			this.setDrUTM();
			// Do tests
			if (this.isTestMode) {
				this.testUtmGenerator();
			}
		} catch (e) {
			console.error(e);
			if (typeof Sentry !== 'undefined') {
				Sentry.captureException(e);
			}
		}
	}

	processUtmData() {
		this.cleanStore();
		this.storeParams();
		this.getStoredParams();
		this.analyzeParams();
		// Set UTM data
		for (let key in this.analyzedParams) {
			if (this.analyzedParams[key]) {
				this.setParam(key, decodeURIComponent(this.analyzedParams[key]).trim());
			}
		}
		// Do some adjustments to match GA tracking
		this.analyseReferrer();
		// Start debugging
		if (typeof Sentry !== 'undefined'
			&& this.utmStorage.read('referrer')
			&& this.getParam('source').match('facebook|instagram|linkedin|twitter|quora|reddit')
			&& this.getParam('medium') !== 'social'
		) {
			Sentry.captureMessage('UTM Parser - medium channel incorrect', {
				level: 'info',
				tags: {
					type: "UtmParser",
				},
				extra: {
					'URL': document.location.href,
					'Referrer': document.referrer,
					'Referrer Info': this.referrer,
					'UTM': this.utm,
				}
			});
		}
		// End debugging
		this.maybeCollectOldUtmData();
		// Check do we need to update UTM params in local store
		if (!this.needToUpdateUTMs() && !this.hasOldUtm) {
			return false;
		}
		// Update local store
		for (let i in this.storeModel) {
			let param = this.storeModel[i];
			window.localStorage.setItem(this.prefix + param['url'], this.getParam(param['utm']));
		}
	}

	setDrUTM() {
		// Put found utm into global window.dr.utm
		window.dr = window.dr || {};
		window.dr.utm = window.dr.utm || {};
		for (let i in this.storeModel) {
			let param = this.storeModel[i];
			window.dr.utm[param['utm']] = window.localStorage.getItem(this.prefix + param['url']);
		}
	}

	cleanStore() {
		for (let i in this.storeModel) {
			let param = this.storeModel[i];
			window.sessionStorage.removeItem(this.prefix + param['url']);
		}
	}

	storeParams() {
		// Collect current UTM data to session store
		// Only existed and relevant params will be written to session store
		this.utmStorage = new StoreParams({
			storage: 'sessionStorage',
			storeReferrer: true,
			storeUTMs: true,
			storePrefix: this.prefix,
			include: [
				{param: 'gclid', rewrite: true},
				{param: 'fbclid', storage: 'fbaid', rewrite: true},
				{param: 'li_fat_id', storage: 'licid', rewrite: true},
				{param: 'mkt_tok', rewrite: true},
			]
		});
		if (this.isTestMode) {
			// Rewrite current data in sessionStorage by test data
			this.setTestData();
		}
		// Add (not set) here for keeping union logic according to GA that
		// utm_source, utm_medium and utm_campaign must always be set.
		// utm_term also has default value.
		// Also, this.isValidUTMs() will always return true for these known cases
		if (this.utmStorage.read('gclid')) {
			// Google payed advertising
			if (!this.utmStorage.read('utm_source')) {
				this.utmStorage.store('utm_source', 'google');
			}
			this.utmStorage.store('utm_medium', 'cpc');
		} else if (this.utmStorage.read('licid')) {
			// Linkedin payed advertising
			if (!this.utmStorage.read('utm_source')) {
				this.utmStorage.store('utm_source', 'linkedin');
			}
			if (!this.utmStorage.read('utm_medium')) {
				this.utmStorage.store('utm_medium', 'display');
			}
		} else if (this.utmStorage.read('mkt_tok')) {
			// Marketo email
			if (!this.utmStorage.read('utm_source')) {
				this.utmStorage.store('utm_source', 'drdatabase');
			}
			if (!this.utmStorage.read('utm_medium')) {
				this.utmStorage.store('utm_medium', 'marketo');
			}
		} else if (this.utmStorage.read('fbaid')) {
			// Facebook click id
			if (!this.utmStorage.read('utm_source')) {
				this.utmStorage.store('utm_source', 'facebook');
			}
			if (!this.utmStorage.read('utm_medium')) {
				this.utmStorage.store('utm_medium', 'social');
			}
		}
		if (this.utmStorage.read('utm_source')) {
			if (!this.utmStorage.read('utm_medium')) {
				this.utmStorage.store('utm_medium', '(not set)');
			}
			if (!this.utmStorage.read('utm_campaign')) {
				this.utmStorage.store('utm_campaign', '(not set)');
			}
		}
		if (this.utmStorage.read('referrer')) {
			this.referrer = parseUrl(this.utmStorage.read('referrer'));
			let organicDomain = this.getOrganicDomain(this.referrer.resource);
			if (!this.utmStorage.read('utm_term') && organicDomain) {
				this.utmStorage.store('utm_term', this.getOrganicUtmTerm(organicDomain));
			}
		}
	}

	getStoredParams() {
		// Process referrer
		if (this.utmStorage.read('referrer')) {
			let referrer = this.utmStorage.read('referrer');
			if (this.isValidUTMs() || (this.isDrRelatedReferrer() && this.isSavedSourceNotImportant())) {
				// Keep referrer for analyse in Sentry reports
				this.setParam('referrer', referrer);
				// According to GA logic if URL has valid utm params
				// (e.g. url has utm_source) - referrer must be ignored
				this.utmStorage.erase('referrer');
				referrer = null;
			}
			this.params['referrer'] = referrer;
		}
		// Process other params
		for (let i in this.storeModel) {
			let param = this.storeModel[i];
			this.params[param['url']] = this.utmStorage.read(param['url']);
		}
	}

	analyzeParams() {
		this.analyzedParams = new AccessData(this.params);
		// Add additional params
		['fbaid', 'licid'].forEach((value) => {
			if (this.params[value]) {
				this.analyzedParams[value] = this.params[value];
			}
		});
		// Fix incorrect params
		if (this.analyzedParams['source'] === 'googleads' && this.analyzedParams['channel'] === 'paid') {
			this.analyzedParams['source'] = 'google';
		} else if (this.analyzedParams['source'] === 'direct' && this.analyzedParams['channel'] === 'direct') {
			this.analyzedParams['source'] = '(direct)';
			this.analyzedParams['medium'] = '(none)';
			this.analyzedParams['campaign'] = '(direct)';
		}
	}

	analyseReferrer() {
		// If there are no utm params in link - we need to process referrer to get traffic source
		if (this.utmStorage.read('referrer')) {
			let clearDomain = this.replaceWwwDomain(this.referrer.resource),
				organicDomain = this.getOrganicDomain(this.referrer.resource),
				socialDomain = this.getSocialDomain(this.referrer.resource),
				content = this.referrer.pathname ? this.referrer.pathname : '/';
			if (organicDomain) {
				// Organic source
				this.setParam('channel', 'organic');
				this.setParam('source', organicDomain);
				this.setParam('medium', 'organic');
				this.setParam('campaign', '(organic)');
			} else if (this.getParam('medium') === 'social' || socialDomain) {
				// Social Media source
				this.setParam('channel', 'social');
				this.setParam('source', socialDomain);
				this.setParam('medium', 'social');
				this.setParam('campaign', '(social)');
				this.setParam('content', content);
			} else {
				// Referrer source
				this.setParam('channel', 'referrer');
				this.setParam('source', clearDomain);
				this.setParam('medium', 'referral');
				this.setParam('campaign', '(referral)');
				this.setParam('content', content);
			}
		}
	}

	maybeCollectOldUtmData() {
		if (!Cookie.get('__utmz')) return false;
		let oldUtms = {};
		for (var cookieName in this.oldCookiesModel) {
			var cookie = this.getOldUtmValue(document.cookie, cookieName, ';');
			if (cookie) {
				if (cookie && typeof this.oldCookiesModel[cookieName] === 'string') {
					oldUtms[this.oldCookiesModel[cookieName]] = decodeURIComponent(cookie).trim();
					continue;
				}
				var cookieStructure = this.oldCookiesModel[cookieName];
				for (var paramName in cookieStructure) {
					var paramValue = this.getOldUtmValue(cookie, paramName);
					if(paramValue) {
						oldUtms[cookieStructure[paramName]] = decodeURIComponent(paramValue).trim();
					}
				}
				let clearName = cookieName.replace('=', '');
				let cookieDomainMatch = window.location.hostname.match(/\..+\..+$/);
				if (cookieDomainMatch) {
					Cookie.remove(clearName, {path: '/', domain: cookieDomainMatch[0]});
				}
			}
		}
		if(Object.keys(oldUtms).length
			&& oldUtms.source && oldUtms.source !== '(direct)'
			&& oldUtms.medium && oldUtms.medium !== 'organic'
			&& oldUtms.campaign && oldUtms.campaign !== '(organic)'
			&& !this.isValidUTMs()
			&& !this.isReferrerMoreImportant()
		) {
			for(let name in oldUtms) {
				if(oldUtms[name]) {
					this.utm[name] = oldUtms[name];
				}
			}
			this.hasOldUtm = true;
		}
	}

	// Helper functions
	needToUpdateUTMs() {
		// Functions are placed depending on their priority
		return this.isValidUTMs()
			|| this.isReferrerMoreImportant()
			|| this.isTrafficSourceMoreImportant();
	}

	isValidUTMs() {
		return this.utmStorage.read('utm_source')
			&& this.utmStorage.read('utm_medium')
			&& this.utmStorage.read('utm_campaign');
	}

	isReferrerMoreImportant() {
		return this.utmStorage.read('referrer')
			&& this.referrer
			&& !this.getOrganicDomain(this.referrer.resource);
	}

	isDrRelatedReferrer() {
		return this.referrer
			&& this.referrer.resource.match(/\.datarobot\.com$/);
	}

	isSavedSourceNotImportant() {
		return window.localStorage.getItem(this.prefix + 'utm_source')
			&& window.localStorage.getItem(this.prefix + 'utm_source') !== '(direct)'
	}

	isTrafficSourceMoreImportant() {
		// Compare current UTM data with stored UTM data
		let localSource = window.localStorage.getItem(this.prefix + 'utm_source');
		let localMedium = window.localStorage.getItem(this.prefix + 'utm_medium');
		let localCampaign = window.localStorage.getItem(this.prefix + 'utm_campaign');
		return this.isEmptyValue(localSource)
			|| localSource === '(direct)'
			|| (localMedium === 'organic' && localCampaign === '(organic)'
				&& !this.isEmpty('source')
				&& this.getParam('source') !== '(direct)')
	}

	getOrganicDomain(domain) {
		domain = this.replaceWwwDomain(domain);
		let searchEng = {
			'google': '^google\\.(com(\\.[a-z]{2})?$|[a-z]{2}$)',	// search, mail, etc. on high-level domains
			'ask': '(^|\\.)ask\\.com$',								// many sub-domains with ask.com but only search
			'baidu': '^(m\\.)?baidu\\.com$',						// search, mail, etc. on high-level domains
			'duckduckgo': '(^|\\.)duckduckgo\\.com$',				// only search
			'ecosia': '^ecosia\\.org$',								// only search
			'lycos': '^search(\\d+)?\\.lycos\\.com$',				// search, mail, etc. on high-level domains
			'bing': '(^|\\.)bing\\.com$',							// search, mail, etc. but only one domain
			'qwant': '^qwant\\.com$',								// search, mail, etc. on high-level domains
			'sogou': '(^|\\.)sogou\\.com$',							// only search
			'startpage': '(^|\\.)startpage\\.com$',					// only search
			'webcrawler': '^webcrawler\\.com$',						// only search
			'yahoo': 'search\\.yahoo\\.(com|co\\.[a-z]{2})$',		// search, mail, etc. on high-level domains
			'yandex': '^yandex\\.(com(\\.[a-z]{2})?|[a-z]{2})$',	// search, mail, etc. on high-level domains
			'daum': 'search\\.daum\\.net$',							// search, mail, etc. on high-level domains
			'naver': 'search\\.naver\\.com$',						// search, mail, etc. on high-level domains
			'aol': 'search\\.aol\\.com$',							// search, mail, etc. on high-level domains
			'seznam': 'search\\.seznam\\.cz$',						// search, mail, etc. but domain structure is not clear
			'rakuten': 'search\\.rakuten\\.co\\.[a-z]{2}$',			// search and shop portal with high-level domains
			'biglobe': 'search\\.biglobe\\.ne\\.[a-z]{2}$',			// search, mail, etc. on high-level domains
			'goo.ne': 'search\\.goo\\.ne\\.[a-z]{2}$',				// search, mail, etc. on high-level domains
			'search.smt.docomo': 'search\\.smt\\.docomo\\.',		// search portal on high-level domains
			'onet': '^szukaj\\.onet\\.pl$',							// search, mail, etc. on high-level domains
			'kvasir': '^kvasir\\.no$',								// only search
			'startsiden': '^startsiden\\.no$',						// only search
			'centrum.cz': 'search\\.centrum\\.cz$',					// search, mail, etc. on high-level domains
			'tut.by': 'search\\.tut\\.by$',							// search, mail, etc. on high-level domains
			'so.com': '^so\\.com$',									// search, mail, etc. on high-level domains
			'auone': 'search\\.auone\\.[a-z]{2}$',					// search, mail, etc. on high-level domains
		};
		for (let name in searchEng) {
			if (domain.match(new RegExp(searchEng[name], 'i'))) {
				return name;
			}
		}
		return null;
	}

	getOrganicUtmTerm(name) {
		// If server setting allow put full url in document.referrer we can fill
		// utm_term value with search terms user used to find current page
		// Example: https://www.baidu.com/s?wd=datarobot
		let searchEng = 'google:q ask:q baidu:word/wd duckduckgo:q ecosia:q lycos:query/q bing:q qwant:q sogou:query webcrawler:q yahoo:p/q yandex:text daum:q naver:query aol:query/q seznam:q rakuten:qt biglobe:q goo.ne:MT search.smt.docomo:MT onet:qt/q kvasir:q startsiden:q centrum.cz:q tut.by:query so.com:q auone:q'.split(' ');
		for (let i in searchEng) {
			let engine = searchEng[i].split(':');
			let domain = engine[0];
			if (domain === name) {
				let searchParams = engine[1].split('/');
				for (let j = 0; j < searchParams.length; j++) {
					let param = searchParams[j];
					if (typeof this.referrer.query[param] !== 'undefined') {
						return this.referrer.query[param];
					}
				}
			}
		}
		return '(not provided)';
	}

	getSocialDomain(domain) {
		domain = this.replaceWwwDomain(domain);
		let socialMedia = {
			'facebook': '(^|\\.)facebook\\.com$',
			'instagram': '(^|\\.)instagram\\.com$',
			'linkedin': '(^|\\.)linkedin\\.|(^|\\.)lnkd\\.in$',
			'youtube': '(^|\\.)youtube\\.com$',
			'twitter': '^twitter\\.com$|^t\\.co$',
			'quora': '(^|\\.)quora\\.com$',
			'reddit': '(^|\\.)reddit\\.com$',
		};
		for (let name in socialMedia) {
			if (domain.match(new RegExp(socialMedia[name], 'i'))) {
				return name;
			}
		}
		return null;
	}

	replaceWwwDomain(domain) {
		if (domain.match(/^www\./)) {
			domain = domain.replace(/^www\./, '');
		}
		return domain;
	}

	isEmptyValue(value) {
		return !value || value === '-';
	}

	isEmpty(param) {
		return this.isEmptyValue(this.getParam(param));
	}

	getParam(param) {
		return this.utm[param];
	}

	setParam(param, value) {
		this.utm[param] = value;
	}

	getOldUtmValue(source, paramName, separator) {
		if (!source || source === "" || !paramName || paramName === "") return null;
		if (!separator || separator === "") separator = '|';
		var utm = null;
		var cookieNameStart = source.indexOf(paramName);
		var valueStart = cookieNameStart + paramName.indexOf("=") + 1;
		if (cookieNameStart > -1) {
			var valueEnd = source.indexOf(separator, cookieNameStart);
			if (valueEnd < 0) {
				valueEnd = source.length;
			}
			utm = source.substring(valueStart, valueEnd);
		}
		return utm;
	}

	// Static functions
	static getUtmValue(name) {
		if (!dr.hasOwnProperty('utm')) {
			dr.utm = {}
		}
		return dr.utm.hasOwnProperty(name) && dr.utm[name] ? dr.utm[name] : UtmGenerator.getDefParamValue(name, 'utm');
	}

	static getCtaValue(name) {
		if (!dr.hasOwnProperty('cta')) {
			dr.cta = {}
		}
		return dr.cta.hasOwnProperty(name) && dr.cta[name] ? dr.cta[name] : UtmGenerator.getDefParamValue(name, 'cta');
	}

	static getDefParamValue(name, type) {
		var model = {
			utm: {
				source: 'utm_source',
				medium: 'utm_medium',
				campaign: 'utm_campaign',
				content: 'utm_content',
				term: 'utm_term',
				gclid: 'gclid',
				fbaid: 'fbclid',
				licid: 'li_fat_id',
			},
			cta: {
				id: 'cta_id',
				name: 'cta_name',
				creative: 'cta_creative',
				position: 'positions',
			},
		};
		var value = '-';
		var tmp = [];

		location.search.substr(1).split("&").forEach(function (item) {
			tmp = item.split("=");
			if (tmp[0] === model[type][name]) {
				value = tmp[1];
				return false;	// to break forEach function
			}
		});

		return value;
	}

	// Tests
	testUtmGenerator(testGroup = '') {
		console.log('<-------start tests------->');
		let referralLinks = getUtmTestData('referral');
		for (let group in referralLinks) {
			if (testGroup && group !== testGroup) continue;
			for (let i in referralLinks[group]) {
				console.log(referralLinks[group][i]);

				// Process utm data
				this.testParams = {'referrer': referralLinks[group][i]};
				this.processUtmData();

				// Compare test results
				if (this.getParam('medium') !== group) {
					console.error('Not match!')
					return false;
				}

				// Clean current utm data
				this.clearUtmObj();
				console.log('-------');
			}
		}
		console.log('<-------end tests------->');
	}

	setTestData() {
		this.cleanStore();
		for (let name in this.testParams) {
			window.sessionStorage.setItem(this.prefix + name, this.testParams[name])
		}
	}

	clearUtmObj() {
		for (let key in this.utm) {
			this.setParam(key, '-');
		}
	}
}
